import React from 'react';
import { Colors } from '../../../../../shared/theme';
import styleText from '../../../../../shared/components/rbh-text/styles';
import commonStyle from '../../../../../shared/theme/common-style';
import metrics from '../../../../../shared/theme/metrics';
export default {
  defaultContent: {
    backgroundColor: Colors.white,
    ...commonStyle.marginTopLarge
  } as React.CSSProperties,
  textPromotion: {
    ...styleText.textRegular14,
    color: Colors.lightPurple,
  },
  iconPromotion: {
    width: 18,
    height: 18,
    marginRight: metrics.baseMargin / 4
  },
  buttonContainer: {
    marginTop: metrics.baseMargin * 2.5
  } as React.CSSProperties
};

export const martCategoryLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

export const buttonLayout = {
  wrapperCol: { offset: 10, span: 16 },
};
